import {
  styled,
  Typography,
  Grid,
  TypographyProps,
  Grow,
  GridProps
} from "@mui/material";
interface MxAlertCardProps extends GridProps {
  children?: React.ReactNode;
  color?: TypographyProps["color"];
}
function MxAlertCard(props: MxAlertCardProps) {
  return (
    // <Grow in={anime} timeout={200}>
    <Content container px={2} pt={3} pb={1} {...props}>
      {props.children}

      {/* <ShapeContent color={color}>
          <Shape />
        </ShapeContent> */}
    </Content>
  );
}

export default MxAlertCard;

const ShapeContent = styled(Typography)(({ theme, color }) => ({
  marginTop: theme.spacing(2),
  width: "100%",
  position: "absolute",
  bottom: 0,
  left: 0,
  "& svg": {
    opacity: 0.3,
    transform: "rotate(180deg)"
  }
}));

const Content = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "auto",
  backgroundColor: "white",
  position: "relative",
  borderRadius: 20,
  overflow: "hidden"
}));
